import { lazy } from 'react';
import Dashboard from '../pages/Dashboard';
// import AddBranch from '../pages/Branch/AddBranch';
import Branches from '../pages/Branch/Branches';
import Brands from '../pages/Brand/Brands';
import Categories from '../pages/Category/Categories';
import Customers from '../pages/Customer/Customers';
import Products from '../pages/Products/Products';
import AddProduct from '../pages/Products/AddProduct';
import EditProduct from '../pages/Products/EditProduct';
import Users from '../pages/User/Users';
import AddUser from '../pages/User/AddUser';
import Profile from '../pages/User/Profile';
import Settings from '../pages/Settings/Settings';
import { Cake } from '@mui/icons-material';
import SubCategories from '../pages/SubCategory/SubCategories';
import Reports from '../pages/Reports/Reports';
import KitchenReports from '../pages/Reports/KitchenReports';
import OrderApproval from '../pages/Approval/Approval';
import PaymentApprovals from '../pages/Payments/PaymentApprovals';
import SalesMan from '../pages/Salesman/SalesMan';
import SalesManList from '../pages/Salesman/SalesManList';
import SweetFactory from '../pages/Factory/SweetFactory';
import CakeFactory from '../pages/Factory/CakeFactory';
import NotificationsPage from '../pages/Notifications';
import Payments from '../pages/Payments/Payments';

// Lazy load order pages
const Orders = lazy(() => import('../pages/Orders/Orders'));
const Order = lazy(() => import('../pages/Orders/Order'));
const CreateOrder = lazy(() => import('../pages/Orders/CreateOrder'));
const OrderDetails = lazy(() => import('../pages/Orders/OderDetails'));
const OrderConfirm = lazy(() => import('../pages/Orders/OrderConfirm'));
const EditOrderDetails = lazy(() => import('../pages/Orders/EditOrderDetails'));
const EditOrder = lazy(() => import('../pages/Orders/EditOrder'));
const ViewOrderPage = lazy(() => import('../pages/Orders/ViewOrderPage'));

// Lazy load cake order pages
const CakeOrder = lazy(() => import('../pages/Cakes/CakeOrder'));
const CakeDetails = lazy(() => import('../pages/Cakes/CakeDetails'));
const EditCakeDetails = lazy(() => import('../pages/Cakes/EditCakeDetails'));
const CakeOrderLists = lazy(() => import('../pages/Cakes/CakeOrderLists'));
const CakeLists = CakeOrderLists; // Use same lazy component for both
const EditCakeOrder = lazy(() => import('../pages/Cakes/EditCakeOrder'));
const CakeOrderConfirm = lazy(() => import('../pages/Cakes/CakeOrderConfirm'));
const WebSocketMonitor = lazy(() => import('../pages/WebSocket/WebSocketMonitor'));


const ROLE_ADMIN = 1;
// const ROLE_MANAGER = 2;
const ROLE_FACTORY = 3;

const routeData = [
  { path: "/dashboard", element: <Dashboard /> },

  // Admin-only routes
  // { path: "/add-branch", element: <AddBranch />, roles: [ROLE_ADMIN] },
  { path: "/branches", element: <Branches />, roles: [ROLE_ADMIN] },
  { path: "/users", element: <Users />, roles: [ROLE_ADMIN] },
  { path: "/add-user", element: <AddUser />, roles: [ROLE_ADMIN] },
  { path: "/approval", element: <OrderApproval />, roles: [ROLE_ADMIN] },
  { path: "/payment-approvals", element: <PaymentApprovals />, roles: [ROLE_ADMIN] },
  { path: "/sales-man", element: <SalesMan />, roles: [ROLE_ADMIN] },
  { path: "/sales-man-list", element: <SalesManList />, roles: [ROLE_ADMIN] },
  { path: "/sweet-factory", element: <SweetFactory />, roles: [ROLE_ADMIN, ROLE_FACTORY] },
  { path: "/cake-factory", element: <CakeFactory />, roles: [ROLE_ADMIN, ROLE_FACTORY] },
  { path: "/ws-monitor", element: <WebSocketMonitor />, roles: [ROLE_ADMIN] },


  // Common routes for all roles
  { path: "/brands", element: <Brands />, roles: [ROLE_ADMIN] },
  { path: "/categories", element: <Categories />, roles: [ROLE_ADMIN] },
  { path: "/sub-categories", element: < SubCategories />, roles: [ROLE_ADMIN] },
  { path: "/customer", element: <Customers />, roles: [ROLE_ADMIN] },
  { path: "/products", element: <Products />, roles: [ROLE_ADMIN] },
  { path: "/add-product", element: <AddProduct />, roles: [ROLE_ADMIN] },
  { path: "/edit-product/:id", element: <EditProduct />, roles: [ROLE_ADMIN] },
  { path: "/orders", element: <Orders /> },
  { path: "/order", element: <Order /> },
  { path: "/create-order", element: <CreateOrder /> },
  { path: "/order-details", element: <OrderDetails /> },
  { path: "/order-confirm", element: <OrderConfirm /> },
  { path: "/edit-order-details/:id", element: <EditOrderDetails /> },
  { path: "/edit-order/:id", element: <EditOrder /> },
  { path: "/profile", element: <Profile /> },
  { path: "/settings", element: <Settings /> },
  { path: "/cake", element: <Cake /> },
  { path: "/cakeorder", element: <CakeOrder /> },
  { path: "/reports", element: <Reports /> },
  { path: "/kitchen-reports", element: <KitchenReports />, roles: [ROLE_ADMIN, ROLE_FACTORY] },
  { path: "/cake-details", element: <CakeDetails /> },
  { path: "/cake-lists", element: <CakeLists /> },
  { path: "/edit-cake-details/:id", element: <EditCakeDetails /> },
  { path: "/cake-orders", element: <CakeOrderLists /> },
  { path: "/edit-cake-order/:id", element: <EditCakeOrder /> },
  { path: "/cake-order-confirm", element: <CakeOrderConfirm /> },
  { path: "/notifications", element: <NotificationsPage /> },
  { path: "/view-order/:id", element: <ViewOrderPage /> },
  { path: "/payments", element: <Payments /> },



]
export default routeData;
